import React, { useState } from 'react'
import AllCheckpointData from '../Dashboard/AllCheckpointData'
import { useCheckpoints, useUserPermissions, useGetAvgTripTime } from '../../services/hooks';
import { Navigate } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { InfoIcon } from '../../services/icons';

const AllTrips = () => {
    const { checkpoints, isLoading } = useCheckpoints();
    const { userPermissions, isFetched } = useUserPermissions();
    const { avgTripTime, getAvgTripTime } = useGetAvgTripTime({});
    const checkpointNumber = checkpoints[0]?.checkpointNumber;
    const checkpointType = checkpoints[0]?.checkpointType;
    const [tripCount, setTripCount] = useState(null);

    const handlePlantFilterChange = (plantIds) => {
      getAvgTripTime(plantIds?.length ? { plantIds } : {});
    };

  if ( isFetched && userPermissions && Object.keys(userPermissions).length && !userPermissions.getAllTrips?.value ) return <Navigate to="/not-authorized" replace />;
  return (
    <div>
      <div className="cust-row flex-algn-cent" style={{ justifyContent: "space-between" }}>
          <div className="cust-col-5">
            <h1 className="title">All Trips
              {tripCount !== null && (
                <span className="trip-count">({tripCount||0})</span>
              )}
            </h1>
          </div>
          {avgTripTime?.avgTripTime && (
              <div style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "17px", fontWeight: "600", color: "var(--text-color)", marginBottom: "4px" }}>
                Avg Trip Time: <span style={{ color: "var(--primary-color)" }}>{avgTripTime.avgTripTime}</span>
                <Tooltip title="Average is based on last 1 week trip data">
                  <InfoIcon sx={{ fill: "var(--primary-color)", fontSize: "20px", cursor: "pointer" }} />
                </Tooltip>
              </div>
          )}
      </div>
      <hr className="bgg" />

      <div className="checkpoint-table-container">
        <div className="checkpoint-table">
          <AllCheckpointData forwordLink={`/checkpoints/${checkpointType}/${checkpointNumber}`} showPagination={true} showHeading={false} plantArray={true} showDownloadExcelButton={true} onTotalCountChange={setTripCount} onPlantFilterChange={handlePlantFilterChange}/>
        </div>
      </div>
    </div>
  )
}

export default AllTrips